import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import { createAction } from 'vuex-action';
import base64 from 'base64url';

Vue.use(Vuex);

const fetchMe = createAction('fetchMe', async () => {
  try {
    const { data } = await axios.get('/api/mkc/v1/refresh-login-session');
    const token = data.token;
    const me = JSON.parse(base64.decode(token.split('.')[1]));
    return me;
  } catch (e) {
    throw new Error(e);
  }
});

const fetchCategories = createAction('fetchCategories', async ({ me }) => {
  try {
    let depth1;
    let genderStr;
    const categories = [];
    if (me.sgndr !== 'A') {
      depth1 = await axios.get('/api/comm/v1/product-categories', { params: { gndr: me.sgndr } });
      genderStr = me.sgndr === 'F' ? 'WOMEN' : 'MEN';
    } else {
      depth1 = await axios.get('/api/comm/v1/product-categories', { params: { gndr: me.sgndr } });
      genderStr = 'UNISEX';

      const depth2 = await axios.get('/api/comm/v1/product-categories', { params: { gndr: 'F' } });
      const children2 = [];
      depth2.data.data.forEach((v) => {
        children2.push({ value: v.cateSeq, label: v.cateName });
      });
      categories.push({
        value: 'F',
        label: 'WOMEN',
        children: children2,
      });

      const depth3 = await axios.get('/api/comm/v1/product-categories', { params: { gndr: 'M' } });
      const children3 = [];
      depth3.data.data.forEach((v) => {
        children3.push({ value: v.cateSeq, label: v.cateName });
      });
      categories.push({
        value: 'M',
        label: 'MEN',
        children: children3,
      });
    }
    const children = [];
    depth1.data.data.forEach((v) => {
      children.push({ value: v.cateSeq, label: v.cateName });
    });
    categories.push({
      value: me.sgndr,
      label: genderStr,
      children,
    });

    return categories;
  } catch (e) {
    throw new Error(e);
  }
});

export default new Vuex.Store({
  state: {
    me: null,
    companyNumber: null,
    categories: null,
  },
  mutations: {
    setMe(state, me) {
      state.me = me;
    },
    fetchMe(state, me) {
      state.me = me;
    },
    fetchCategories(state, categories) {
      state.categories = categories;
    },
    setCompanyNumber(state, number) {
      state.companyNumber = number;
    },
  },
  actions: {
    fetchMe,
    fetchCategories,
  },
});
